import isBlank from 'is-blank'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String
    },
    position: {
      type: String,
      default: () => 'left',
      validator: value => ['left', 'right'].includes(value)
    }
  },
  computed: {
    classes () {
      return {
        [`nav-bar-entry--${this.position}`]: true
      }
    },
    hasIcon () {
      return !isBlank(this.icon)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ui/NavBarEntry.js